import axios from 'axios';
import Common from '../../componets/Common';

const initialData = {
  mensajeError: ""
}

export const obtenerPagoPowerpay = async (idOrdenPago) => {
  const url = `${Common.urlAPI}/ObtenerPagoPowerpay/${idOrdenPago}`;
  try {
    const resPaymentGet = await axios.get( url );
    
    return {
      ...initialData,
      ...resPaymentGet.data,
    }; 
  } catch (err) {
    console.log('error', err);
    const mensajeError = err.response && err.response.status === 401 ? err.response.data.message : err.toString();
    return {
      ...initialData,
      mensajeError      
    }
  }
}
